import React from 'react';
import c from 'classnames';

import { SearchkitWrapper } from '@uncinc/react-searchkit';
import { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';

import { APP_OPTIONS, SEARCHKIT_HOST_URL } from '../../config/constants';
import defaultSearchSettings from './config';

import './style.scss';

// Subcomponents.
import ActiveFacets from './ActiveFacets';
import AutosuggestHit from './AutosuggestHit';
import Facets from './Facets';
import Results from './Results';
import SearchBar from './SearchBar';
import SearchBarAutosuggest from './SearchBarAutosuggest';
import Stats from './Stats';

interface SearchAllContentSubComponents {
  ActiveFacets: typeof ActiveFacets;
  AutosuggestHit: typeof AutosuggestHit;
  Facets: typeof Facets;
  Results: typeof Results;
  SearchBar: typeof SearchBar;
  SearchBarAutosuggest: typeof SearchBarAutosuggest;
  Stats: typeof Stats;
}

export interface SearchAllContentProps extends Omit<SearchkitWrapperProps, 'connection' | 'indexName' | 'searchSettings'> {
  className?: string;
  searchSettings?: SearchkitWrapperProps['searchSettings'];
}

// eslint-disable-next-line max-len
const SearchAllContent: React.FC<SearchAllContentProps> & SearchAllContentSubComponents = (props) => {
  const {
    className,
    routing,
    children,
    searchSettings,
    ...restProps
  } = props;

  const classNames = c('SearchAllContent', className);

  return (
    <SearchkitWrapper
      {...restProps}
      className={classNames}
      connection={{
        host: SEARCHKIT_HOST_URL,
      }}
      routing={routing}
      indexName={APP_OPTIONS.parameters.searchkitIndexAllContent}
      searchSettings={searchSettings ?? defaultSearchSettings}
    >
      {children}
    </SearchkitWrapper>
  );
};

SearchAllContent.ActiveFacets = ActiveFacets;
SearchAllContent.AutosuggestHit = AutosuggestHit;
SearchAllContent.Facets = Facets;
SearchAllContent.Results = Results;
SearchAllContent.SearchBar = SearchBar;
SearchAllContent.SearchBarAutosuggest = SearchBarAutosuggest;
SearchAllContent.Stats = Stats;

export default SearchAllContent;
